import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FloorSelectionItem from './FloorSelectionItem';
import findIndex from 'lodash/findIndex';
import { connect } from 'react-redux';
import {
	canAddZoneAsso,
	canRemoveZoneAsso,
	getAccess,
} from '../selectors/access.selector';
import Alert from './Alert';
import { I18n } from 'react-redux-i18n';
import { Chip, IconButton, Tooltip } from '@material-ui/core';
import { DoneAll } from '@material-ui/icons';

class FloorSelection extends Component {
	constructor(props) {
		super(props);

		this.onSelectedChange = this.onSelectedChange.bind(this);
		this.selectAllFloorExclusion = this.selectAllFloorExclusion.bind(this);
		this.deselectAllFloorExclusion = this.deselectAllFloorExclusion.bind(this);
		this.getGroupingSelector = this.getGroupingSelector.bind(this);
		this.onSelectGroup = this.onSelectGroup.bind(this);
	}

	componentWillReceiveProps(nextProps) {}

	/*
        Renvoie la liste des salles selectionée (à la fonction onChange) sous la forme d'un tableau d'objets : { id , counter_type }
     */
	onSelectedChange(floor) {
		let selected = [...this.props.floorsSelected];

		let index = findIndex(selected, function (f) {
			return f.id === floor.id && f.counter_type === floor.counter_type;
		});
		if (index > -1) {
			selected.splice(index, 1);
		} else {
			selected.push({
				id: floor.id,
				counter_type: floor.counter_type,
				name: floor.name,
			});
		}

		this.props.onChange(selected);
	}

	onSelectGroup(weight, deselect) {
		let selected = [...this.props.floorsSelected];
		const floorsGroup = this.props.floors.filter(f => f.weight == weight);
		if (deselect) {
			selected = selected.filter(
				fs =>
					!floorsGroup.find(
						f => fs.id == f.id && f.counter_type == fs.counter_type
					)
			);
		} else {
			floorsGroup.forEach(f => {
				if (
					!selected.find(
						fs => fs.id == f.id && fs.counter_type == fs.counter_type
					)
				) {
					selected.push({
						id: f.id,
						counter_type: f.counter_type,
						name: f.name,
					});
				}
			});
		}

		this.props.onChange(selected);
	}

	selectAllFloorExclusion() {
		let selected = this.props.floors.map(floor => ({
			id: floor.id,
			counter_type: floor.counter_type,
			name: floor.name,
		}));
		this.props.onChange(selected);
	}

	deselectAllFloorExclusion() {
		this.props.onChange([]);
	}

	// renvoie les selecteur de noms de salles similaire, nouvelle feature waohou
	getGroupingSelector() {
		const floorsByWeigth = this.props.floors.reduce((acc, floor) => {
			if (!acc[floor.weight]) acc[floor.weight] = [];
			acc[floor.weight].push(floor);
			return acc;
		}, {});
		return Object.values(floorsByWeigth);
	}

	render() {
		const { floors } = this.props;
		const { selectedIcon, floorsSelected } = this.props;

		const floorsByGroup = this.getGroupingSelector();

		const groupMode = floorsByGroup.some(floorGroup => floorGroup.length > 1); // savoir si on est en group mode ou non

		const accessDisabled =
			!this.props.accessExclusion.update ||
			!canAddZoneAsso(this.props.accessZone) ||
			!canRemoveZoneAsso(this.props.accessZone);

		return (
			<div>
				{accessDisabled ? (
					<Alert type={'warning'}>
						<p>{I18n.t('floor.alert_floor_mapping')}</p>
					</Alert>
				) : null}
				<div style={{ marginBottom: 10 }}>
					<Chip
						onClick={accessDisabled ? null : this.selectAllFloorExclusion}
						label={I18n.t('product.form.exclusion_select_all')}
						style={{ marginRight: 10 }}
					/>
					<Chip
						onClick={accessDisabled ? null : this.deselectAllFloorExclusion}
						label={I18n.t('product.form.exclusion_deselect_all')}
					/>
				</div>
				<div
					style={{
						display: 'flex',
						flexWrap: 'wrap',
						flexDirection: groupMode ? 'column' : 'row',
						alignItems: groupMode ? 'flex-start' : 'initial',
					}}>
					{groupMode
						? floorsByGroup.map(floorGroup => {
								const groupSelected = floorGroup.every(f =>
									floorsSelected.find(
										fs => f.id === fs.id && f.counter_type === fs.counter_type
									)
								);
								return (
									<div style={{ display: 'flex', flexWrap: 'wrap' }}>
										{floorGroup.length > 1 ? (
											<Tooltip
												title={I18n.t('product.form.exclusion_select_grouo')}>
												<IconButton
													size="small"
													classes={{
														root: `${groupSelected ? 'mui-chip_selected' : ''}
						}`,
													}}
													onClick={() =>
														this.onSelectGroup(
															floorGroup[0].weight,
															groupSelected
														)
													}>
													<DoneAll fontSize="small" />
												</IconButton>
											</Tooltip>
										) : null}

										{floorGroup.map(f => {
											// gérer duplication de code avec en dessous
											let index = findIndex(floorsSelected, function (floor) {
												return (
													f.id === floor.id &&
													f.counter_type === floor.counter_type
												);
											});
											let isSelected = index > -1;
											return (
												<FloorSelectionItem
													key={f.id + '#' + f.counter_type}
													name={f.name}
													counter_type={f.counter_type}
													selected={!!isSelected}
													id={f.id}
													onSelectedChange={this.onSelectedChange}
													selectedIcon={selectedIcon}
													disabled={accessDisabled}
												/>
											);
										})}
									</div>
								);
							})
						: floors.map(f => {
								let index = findIndex(floorsSelected, function (floor) {
									return (
										f.id === floor.id && f.counter_type === floor.counter_type
									);
								});
								let isSelected = index > -1;
								return (
									<FloorSelectionItem
										key={f.id + '#' + f.counter_type}
										name={f.name}
										counter_type={f.counter_type}
										selected={!!isSelected}
										id={f.id}
										onSelectedChange={this.onSelectedChange}
										selectedIcon={selectedIcon}
										disabled={accessDisabled}
									/>
								);
							})}
				</div>
			</div>
		);
	}
}

FloorSelection.propTypes = {
	floors: PropTypes.array.isRequired,
	floorsSelected: PropTypes.array.isRequired,
	onChange: PropTypes.func.isRequired,
	selectedIcon: PropTypes.string,
};

const mapStateToProps = state => {
	return {
		accessExclusion: getAccess(state.access, 'exclusion'),
		accessZone: state.access.config,
	};
};

export default connect(mapStateToProps)(FloorSelection);
